/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PdsQuoteExportStatusQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  docId: Types.Scalars['ID']['input'];
}>;


export type PdsQuoteExportStatusQuery = { pdsQuoteExportStatus: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PdsQuoteExportState', status: Types.PdsQuoteExportStatus, pdsNumber?: string | null, errorMessage?: string | null } };

export type ExportQuoteToPdsMutationVariables = Types.Exact<{
  input: Types.ExportQuoteToPdsInput;
}>;


export type ExportQuoteToPdsMutation = { exportQuoteToPds: { __typename: 'PdsQuoteExportState', status: Types.PdsQuoteExportStatus, pdsNumber?: string | null, errorMessage?: string | null } };


export const PdsQuoteExportStatusDocument = gql`
    query PdsQuoteExportStatus($projectId: ID!, $docId: ID!) {
  pdsQuoteExportStatus(projectId: $projectId, docId: $docId) {
    ... on PdsQuoteExportState {
      status
      pdsNumber
      errorMessage
    }
  }
}
    `;

/**
 * __usePdsQuoteExportStatusQuery__
 *
 * To run a query within a React component, call `usePdsQuoteExportStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePdsQuoteExportStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePdsQuoteExportStatusQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      docId: // value for 'docId'
 *   },
 * });
 */
export function usePdsQuoteExportStatusQuery(baseOptions: Apollo.QueryHookOptions<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables> & ({ variables: PdsQuoteExportStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables>(PdsQuoteExportStatusDocument, options);
      }
export function usePdsQuoteExportStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables>(PdsQuoteExportStatusDocument, options);
        }
export function usePdsQuoteExportStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables>(PdsQuoteExportStatusDocument, options);
        }
export type PdsQuoteExportStatusQueryHookResult = ReturnType<typeof usePdsQuoteExportStatusQuery>;
export type PdsQuoteExportStatusLazyQueryHookResult = ReturnType<typeof usePdsQuoteExportStatusLazyQuery>;
export type PdsQuoteExportStatusSuspenseQueryHookResult = ReturnType<typeof usePdsQuoteExportStatusSuspenseQuery>;
export type PdsQuoteExportStatusQueryResult = Apollo.QueryResult<PdsQuoteExportStatusQuery, PdsQuoteExportStatusQueryVariables>;
export const ExportQuoteToPdsDocument = gql`
    mutation ExportQuoteToPds($input: ExportQuoteToPdsInput!) {
  exportQuoteToPds(input: $input) {
    status
    pdsNumber
    errorMessage
  }
}
    `;
export type ExportQuoteToPdsMutationFn = Apollo.MutationFunction<ExportQuoteToPdsMutation, ExportQuoteToPdsMutationVariables>;

/**
 * __useExportQuoteToPdsMutation__
 *
 * To run a mutation, you first call `useExportQuoteToPdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportQuoteToPdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportQuoteToPdsMutation, { data, loading, error }] = useExportQuoteToPdsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportQuoteToPdsMutation(baseOptions?: Apollo.MutationHookOptions<ExportQuoteToPdsMutation, ExportQuoteToPdsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportQuoteToPdsMutation, ExportQuoteToPdsMutationVariables>(ExportQuoteToPdsDocument, options);
      }
export type ExportQuoteToPdsMutationHookResult = ReturnType<typeof useExportQuoteToPdsMutation>;
export type ExportQuoteToPdsMutationResult = Apollo.MutationResult<ExportQuoteToPdsMutation>;
export type ExportQuoteToPdsMutationOptions = Apollo.BaseMutationOptions<ExportQuoteToPdsMutation, ExportQuoteToPdsMutationVariables>;